module.exports = __webpack_public_path__ + "static/media/mesh basket.17.0d39912b.png";